import { gql } from "@apollo/client";

const GET_BOT = gql`
  query GetBot($botId: String!) {
    getBot(botId: $botId) {
      id
      botId
      name
      description
      systemPrompt
      handoffEnabled
      handoffConfidenceThreshold
      handoffAfterMessages
      language
      fallbackMessage
      # UI Config
      primaryColor
      secondaryColor
      backgroundColor
      borderRadius
      position
      avatarUrl
      launcherImageUrl
      darkMode
      welcomeMessage
      placeholderText
      autoOpen
      autoOpenDelay
      typingAnimation
      botTakeoverName
      agentTakeoverName
      soundEnabled
      enabled
      links
      createdAt
      deployments {
        id
        deploymentId
        channelType
        channelId
        channelName
        enabled
        totalConversations
        totalHandoffs
      }
      knowledgeSources {
        id
        sourceId
        sourceType
        sourceName
        status
        totalChunks
        createdAt
        processedAt
        errorMessage
        processingProgress
      }
    }
  }
`;

export default GET_BOT;
